export default __webpack_public_path__ + "static/media/logo.0adb5320.svg";